import { MyApiRequest } from '../../my-api';

const KUBO_INDEX = 'kubo';

export function getKubo(request: MyApiRequest) {
    return {};
}
